<template>
  <div class="operate-list">
    <div class="nav">
      <el-form :inline="true" :model="searchForm" class="operate-form-inline">
        <el-form-item label="操作人:">
          <el-input v-model="searchForm.empNm" size='mini' placeholder="请输入操作人"></el-input>
        </el-form-item>
        <el-form-item label="操作类型:">
          <el-input v-model="searchForm.operateType" size='mini' placeholder="请输入操作类型"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="tableContent">
        <el-table
          v-loading = "tableLoading"
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style='headerCellStyle'
          >
          <el-table-column align="center" prop="empNm" label="操作人" />
          <el-table-column align="center" prop="operateType" label="操作类型" />
          <el-table-column align="center" prop="count" label="统计次数" />
        </el-table>
      </div>
    </div>
    <div class='paginationContainer'>
      <el-pagination
        background
        :page-sizes='[10, 20, 30, 40]'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='contractSizeChange'
        @current-change='contractCurrentChange'
        :current-page.sync='searchForm.page'
        :page-size='searchForm.rows'
      />
    </div>
  </div>
</template>

<script>
import {operateRecordReport} from '@/service/vehiclelog';
import { baseUrl } from '@/config/env';
export default {
  name: "index.vue",
  data() {
    return {
      searchForm: {
        empNm: '',
        operateType: '',
        page: 1,
        rows: 10,
      },
      total: 0,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      tableLoading: false,
    }
  },
  methods:{
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getTableData();
    },
    // 重置
    resetBtn() {
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      this.shippingDate = ['', ''];
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await operateRecordReport({
        ...this.searchForm,
      });
      this.tableLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data.records;
      this.total = data.total;
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    }
  }
}
</script>

<style scoped>
  .operate-list{
    padding: 20px 15px 0 20px;
    height: 100%;
    .nav {
      display: flex;
      overflow: hidden;
      margin: 0 100px 20px 100px;

      .el-input {
        width: 170px;
      }

      .el-form-item__label {
        font-weight: 500;
        color: #101010;
      }

      .el-form-item{
        margin-right: 150px;
      }

      .searchBtn resetBtn{
        font-size: 12px;
        color: rgba(51, 84, 131, 100);
        font-weight: 500;
      }
    }
    .tableContent {
      margin: 10px 0 30px 0;
    }


  }

</style>
